import { BreadCrumb } from "primereact/breadcrumb";
import { useEffect, useState } from "react";
import AdmissionRequestService from "../../../api/AdmissionRequestService";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import EmptyMessage from "../../../components/datatable/EmptyMessage";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import SearchComponent from "../../../components/datatable/SearchComponent";
import ActionBtn from "../../../components/dashboard/btn/ActionBtn";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routes";
import { Chip } from "primereact/chip";

export default function Archivates() {
  const navigate = useNavigate();
  const items = [
    { label: "Candidatures" },
    { label: "Archives" },
    { label: "Liste" },
  ];
  const candidate = {
    icon: "pi pi-wallet",
    url: routes.dashboard.candidateArchives.path,
  };
  const [admissionRequests, setAdmissionRequests] = useState([]);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    //name: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const [loading, setLoading] = useState(true);
  const actionTemplate = (rowData) => {
    return (
      <div className="flex justify-content-start gap-3 align-items-center">
        <ActionBtn
          icon="pi pi-eye"
          severity="primary"
          tooltip="Consulter"
          handleClick={() =>
            navigate(routes.dashboard.candidates.path + `/${rowData.id}`)
          }
        />
      </div>
    );
  };
  useEffect(() => {
    AdmissionRequestService.getArchivated()
      .then((res) => {
        setAdmissionRequests(res.data.admissionRequests);
        setLoading(false);
      })
      .catch((err) => console.log("err", err));
  }, []);
  const header = () => {
    return (
      <div className="flex justify-content-end">
        <SearchComponent
          globalFilterValue={globalFilterValue}
          onGlobalFilterChange={onGlobalFilterChange}
        />
      </div>
    );
  };

  return (
    <div className="pl-2 pr-2">
      <BreadCrumb model={items} home={candidate} />

      <div className="">
        <DataTable
          value={admissionRequests}
          tableStyle={{ minWidth: "50rem" }}
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          dataKey="id"
          filters={filters}
          loading={loading}
          //globalFilterFields={["name"]}
          header={header}
          emptyMessage={EmptyMessage}
        >
          <Column
            body={(rowData) =>
              rowData.user.lastname + " " + rowData.user.firstname
            }
            header="Candidat"
            style={{ width: "20%" }}
          ></Column>
          <Column
            body={(rowData) => rowData.user.email}
            header="Email"
            style={{ width: "20%" }}
          ></Column>

          <Column
            body={(rowData) =>
              rowData.branche_training_program?.branche?.name +
              " - " +
              rowData.branche_training_program?.training_program?.name
            }
            header="Site - Parcours"
            //style={{ width: "20%" }}
          ></Column>

          <Column
            header="Statut"
            //style={{ width: "10%" }}
            body={(rowData) =>
              rowData.level == 0 ? (
                <Chip label="Preselection"></Chip>
              ) : rowData.level == 1 ? (
                <Chip label="Entretien"></Chip>
              ) : rowData.level == 2 ? (
                <Chip label="Prairie"></Chip>
              ) : (
                <Chip label="Selectionner"></Chip>
              )
            }
          ></Column>
          <Column
            field="average_preselection"
            header="Moyenne Préselection / 20"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="average_interview"
            header="Moyenne Entretien / 20"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="average_challenge"
            header="Moyenne Prairie / 20"
            style={{ width: "10%" }}
          ></Column>
          <Column
            header="Action"
            body={actionTemplate}
            // style={{ width: "30%" }}
          ></Column>
        </DataTable>
      </div>
    </div>
  );
}
